// automatic written by ruby script .. please dont edit these comments!
// storyblok attributes:
//   table -> table
//   test -> richtext
//   markdown -> markdown
// end of automatic

import React from "react"
import Richtext from "../atoms/Richtext"
import BlockWrapper from "../technical/BlockWrapper"

import ReactMarkdown from "react-markdown"

const TableBlock = ({ block }) => {
  return (
    <BlockWrapper block={block}>
      {block.table !== "" && (
        <div className="mt-8 prose max-w-none table-responsive">
          <table>
            <thead>
              <tr>
                {block.table?.thead?.length > 0 &&
                  block.table.thead.map((thead, index) => (
                    <th key={`thead-${index}`}>{thead.value}</th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {block.table?.tbody?.length > 0 &&
                block.table.tbody.map((row, trindex) => (
                  <tr key={`tr-${trindex}`}>
                    {row.body?.length > 0 &&
                      row.body.map((item, index) => (
                        <td key={`tr-${trindex}-td-${index}`}>{item.value}</td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
      <Richtext text={block.markdown} className="mt-8 table-responsive" />
    </BlockWrapper>
  )
}

export default TableBlock
